<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right">
      <div>
        <el-button @click="selects(1)">查询</el-button>
        <el-button @click="selects_sy">同步队列</el-button>
        <el-button @click="moneyexcels">导出报表</el-button>
        <div>
            <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
              <el-descriptions-item label="房产信息">
                <el-select v-model="date.house" size="mini" placeholder="可搜索房产" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">
                    <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item label="查询方式">
                <Space direction="vertical" size="large">
                  <RadioGroup v-model="date.type">
                      <Radio label="模糊查询"></Radio>
                      <Radio label="精确查询"></Radio>
                  </RadioGroup>
                </Space>
              </el-descriptions-item>
              <el-descriptions-item  label="计费周期">
                <el-date-picker v-model="date.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
                <span style="margin-left: 1px;margin-right: 1px;">至</span>
                <el-date-picker v-model="date.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
              </el-descriptions-item>
              <!-- <el-descriptions-item  label="缴款时间">
                <el-date-picker v-model="date.startDate1" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
                <span style="margin-left: 1px;margin-right: 1px;">至</span>
                <el-date-picker v-model="date.endDate1" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
              </el-descriptions-item> -->
              <el-descriptions-item  label="生成时间">
                <el-date-picker v-model="date.startDate2" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
                <span style="margin-left: 1px;margin-right: 1px;">至</span>
                <el-date-picker v-model="date.endDate2" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
              </el-descriptions-item>
              <el-descriptions-item label="收费项目">
                <el-select v-model="date.chargeitem_id" size="mini" multiple filterable collapse-tags placeholder="收费项目" style="width: 80.5%;">
                    <el-option v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
                </el-select>
                <span style="cursor: pointer;margin-left: 3px;" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel">取消</span>
              </el-descriptions-item>
              <el-descriptions-item label="显示方式">
                <Space direction="vertical" size="large">
                  <RadioGroup v-model="date.money_type">
                      <Radio label="汇总"></Radio>
                      <!-- <Radio label="明细"></Radio> -->
                  </RadioGroup>
                </Space>
              </el-descriptions-item>
              <el-descriptions-item label="费用类型">
                <Space direction="vertical" size="large">
                  <RadioGroup v-model="date.money_type_cha">
                      <Radio label="全部"></Radio>
                      <!-- <Radio label="未缴款"></Radio>
                      <Radio label="部分缴款"></Radio> -->
                      <Radio label="已缴款"></Radio>
                  </RadioGroup>
                </Space>
              </el-descriptions-item>
              <el-descriptions-item label="收费项目">
                <Space direction="vertical" size="large">
                  <RadioGroup v-model="date.chargeItem_type">
                      <Radio label="新视窗收费项目为准"></Radio>
                      <Radio label="财到家收费项目为准"></Radio>
                  </RadioGroup>
                </Space>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="结算方式">
                <RadioGroup v-model="date.pay">
                  <div style="display: flex;flex-wrap: wrap;">
                    <div v-for="it in dataPay" :key="it.id">
                        <Radio :label="it.number">{{it.name}}</Radio>
                    </div>
                  </div>
                </RadioGroup>
              </el-descriptions-item> -->
            </el-descriptions>
        </div>
        <div style="margin-top: 10px;" v-if="date.money_type == '汇总'">
          <span >说明：<span style="color: red;">同步账单，到家总金额-新视窗总金额=差异金额，有差异点同步，等待同步队列完成，同步结束</span>
          </span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="49vh">
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <!-- <el-button @click="orders(1,scope.row)" v-if="ERP.isPermission(40360004001)">同步一致</el-button> -->
                <el-button @click="orders(2,scope.row)" v-if="ERP.isPermission(40360004002)">同步</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="chargeItemID" label="ID" width="50"></el-table-column>
            <el-table-column prop="name" label="收费项目" width="150"></el-table-column>
            <el-table-column prop="charge" label="到家总金额" width="130"></el-table-column>
            <el-table-column prop="cdj_charge" label="到家科技生成金额" width="130"></el-table-column>
            <el-table-column prop="charge1" label="新视窗总金额" width="130"></el-table-column>
            <el-table-column label="总差异金额" width="130">
              <template slot-scope="scope">
                <div style="color: red;">{{scope.row.sun}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="PaidChargeSum" label="到家已缴金额" width="130"></el-table-column>
            <el-table-column prop="PaidChargeSum1" label="新视窗已缴金额" width="130"></el-table-column>
            <el-table-column label="已缴差异金额" width="130">
              <template slot-scope="scope">
                <div style="color: red;">{{(scope.row.PaidChargeSum-scope.row.PaidChargeSum1).toFixed(2)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="到家减免金额" width="130"></el-table-column>
            <el-table-column prop="discount1" label="新视窗减免金额" width="130"></el-table-column>
            <el-table-column label="减免差异金额" width="130">
              <template slot-scope="scope">
                <div style="color: red;">{{(scope.row.discount-scope.row.discount1).toFixed(2)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="delaySum" label="到家违约金" width="130"></el-table-column>
            <el-table-column prop="delaySum1" label="新视窗违约金" width="130"></el-table-column>
            <el-table-column label="违约金差异金额" width="130">
              <template slot-scope="scope">
                <div style="color: red;">{{(scope.row.delaySum-scope.row.delaySum1).toFixed(2)}}</div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" width="400">
              <template slot-scope="scope">
                <el-button @click="orders(1,scope.row)" v-if="ERP.isPermission(40360004001)">同步一致</el-button>
                <el-button @click="orders(2,scope.row)" v-if="ERP.isPermission(40360004002)">同步</el-button>
                <el-button @click="orders(4,scope.row)" v-if="ERP.isPermission(40360004003)">同步减免</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
        <div style="margin-top: 10px;" v-if="date.money_type == '明细'">
          <span>说明</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="49vh"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="收费项目" width="200"></el-table-column>
            <el-table-column prop="xsc_Price" label="收费标准" width="200"></el-table-column>
            <el-table-column prop="xsc_Amount" label="单价" width="100"></el-table-column>
            <el-table-column label="计费周期" width="180">
              <template slot-scope="scope">
                {{scope.row.startDate}}-{{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="charge_paid" label="到家科技金额" width="120"></el-table-column>
            <el-table-column prop="charge_paid" label="到家科技已缴金额" width="120"></el-table-column>
            <el-table-column prop="dis_count" label="新视窗金额" width="120"></el-table-column>
            <el-table-column prop="charge_paid" label="新视窗已缴金额" width="120"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pages">
        <Page :total="total" :page-size="page" @on-change="selects" show-total />
      </div>
    </div>
    <synchronization ref="synchronization"></synchronization>
    <Moneyexcel ref="moneyexcel"></Moneyexcel>
  </div>
</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js";
// print-is
import print from "print-js";
export default {
  name: "OrderListDate",
  components: {
    "Moneyexcel": () => import('./Moneyexcel.vue'),
    "synchronization": () => import('./synchronization.vue'),
    "ErpTree": () => import('../../Common/erp-tree')
  },
  data() {
    return {
      total:0,
      page:50,
      type:1,
      loading_dade:1,
      dialogVisible:false,
      tableData: [],
      order: [],
      money_val:0,
      money:0,
      date:{
        pindex_id:'',
        startDate:'',
        endDate:'',
        startDate1:'',
        endDate1:'',
        startDate2:'',
        endDate2:'',
        type:'模糊查询',
        xsc_bill_no:'',
        money_type:"汇总",
        money_type_cha:"全部",
        chargeitem_id:[],
        house:'',
        pay:'',
        chargeItem_type:'新视窗收费项目为准',
      },
      customer:[],
      dataPay:[],
      xsc_bill_no:'',
      house:[],
      chargeitem:[],
      loading:false,
    };
  },
  //界面没出来前加载
  created() {

  },
  // 加载数据
  mounted() {
    //加载收费大类（费项）
    this.$myhttp.get("admin/common/getChargeitem", {
        "Content-Type": "application/json",
    }).then((backdata) => {
      this.chargeitem = backdata.data.data;
    });
    //加载收款方式
    this.$myhttp.get('admin/OrderPayment/index',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
          let dataPay = backdata.data.data;
          this.dataPay = dataPay;
    });
    //最近7天
    this.$myhttp.get('xsc/OrderComparisonMoney/dates',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
          let date = backdata.data.data;
          // this.date.startDate2 = date.date_s;
          // this.date.endDate2 = date.date_e;
    });
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  //事件
  methods: {
    selects_sy(){
      this.$refs.synchronization.getInvo();
    },
    moneyexcels(){
       this.$refs.moneyexcel.getInvo(this.date);
    },
    // 查询
    selects(e){
      if(this.date.pindex_id == ""){
        this.$confirm('点击左边树选择项目', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

        })
        return false;
      }
      this.loading_dade = 2;
      this.date.page = e;
      this.$myhttp.post('xsc/OrderComparisonMoney/select',this.date,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.loading_dade = 1;
          if(backdata.data.code == 200){
            this.tableData = backdata.data.data;
          }else{
            this.$confirm(''+backdata.data.message, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

            })
          }
          //this.tableData = backdata.data.data;
      },err=>{
        this.loading_dade = 1;
        this.$Message.error('请求异常!');
      });
    },
    //同步账单
    orders(type,data){
      this.$confirm('确定要同步吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.date.order_type = type;
        this.date.order_data = data;
        this.$myhttp.post('xsc/OrderComparisonMoney/order',this.date,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            if(backdata.data.code == 200){
              this.$refs.synchronization.getInvo();
            }else{
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {

              })
            }
        },err=>{
          this.loading_dade = 1;
          this.$Message.error('请求异常!');
        });
      })
    },
    nodeClick(data) {
      let project = data.tree[0];
      this.date.pindex_id = project.pindex_id;
      let tree_str = data.tree.map((ret) => {return ret.name;}).join("->");
      this.date.house = tree_str;
      this.selects(1);
    },
    //远程搜索
    remoteMethod(query){
      if (query !== '') {
        this.$myhttp.get('admin/common/house_name1?house_name='+query+'&pindex_id='+this.date.pindex_id,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.house = backdata.data.data;
        });
      }
    },
    //全选
    complete() {
      let data = this.chargeitem;
      let id = data.map((ret) => {return ret.id;}).join(",");
      let idarray = "[" + id + "]";
      this.select.chargeitem_id = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.select.chargeitem_id = [];
    },
    handleSelectionChange(val) {
      this.order = val;
      let money = 0;
      this.order.map(req=>{
          money = Number(money) + Number(req.charge_paid);
      })
      this.money_val = money.toFixed(2);
    },
    // 获取上一周的开始结束时间
    getLastWeekDays() {
        let data = new Date()-3600*1000*24*7;
        return data;
    },
  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/Comparison/Money.vue